export default __webpack_public_path__ + "static/media/coolwinks.654adb31.jpg";